import { apiFetch } from "./client";

const getComboArray = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.combos)) return data.combos;
  return [];
};

const toFiniteNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const getTextValue = (...values) => {
  for (const value of values) {
    const normalized = String(value ?? "").trim();
    if (normalized) return normalized;
  }
  return "";
};

const normalizeCombo = (combo, index) => {
  const price = toFiniteNumber(combo?.price);
  const sellingPrice = toFiniteNumber(
    combo?.selling_price ?? combo?.sellingPrice
  );
  const comboPrice = toFiniteNumber(combo?.combo_price);
  const regularPrice = price ?? sellingPrice ?? comboPrice ?? 0;
  const strikePrice = comboPrice ?? price ?? sellingPrice ?? regularPrice;

  return {
    ...combo,
    id: combo?.id ?? combo?.combo_id ?? `combo-${index}`,
    name: getTextValue(combo?.name, combo?.title, combo?.combo_name, `Combo ${index + 1}`),
    brand: getTextValue(combo?.brand, combo?.category_name, combo?.category),
    image: getTextValue(combo?.image, combo?.image_url, combo?.thumbnail, combo?.combo_image),
    price: regularPrice,
    combo_price: strikePrice,
    points: toFiniteNumber(combo?.points) ?? 0,
    member_points: toFiniteNumber(combo?.member_points ?? combo?.memberPoints) ?? 0,
    products: Array.isArray(combo?.products) ? combo.products : [],
  };
};

const normalizeComboList = (data) => getComboArray(data).map(normalizeCombo);

export const fetchCombos = async () => {
  const response = await apiFetch("/enduser/combos/", {
    credentials: "include",
  });

  return normalizeComboList(response);
};

export const fetchComboById = (id) =>
  apiFetch(`/enduser/combos/${id}/`, {
    credentials: "include",
  });
